// src/components/watchDetail/TokenStats/TokenStats.js
import React from "react";
import PropTypes from "prop-types";
import { TrendingUp } from "lucide-react";
import "./TokenStats.css";
import firstBadge from "../../../../assets/first-badge.png";
import secondBadge from "../../../../assets/second-badge.png";
import thirdBadge from "../../../../assets/third-badge.png";
import CryptoIconWrapper from "../../../cryptoicons/CryptoIconWrapper";

const BADGES = [firstBadge, secondBadge, thirdBadge];

const TokenStats = ({ tokens, showStats }) => {
  return (
    <div className="token-stats-grid">
      {tokens.map((token, index) => (
        <div
          key={token.symbol}
          className={`token-stat-card relative position-${index + 1}`}
        >
          <div className="absolute -top-4 -left-4">{index < 3 && <img src={BADGES[index]} alt="Badge" />}</div>
          <div className="flex flex-col">
            <div className="flex gap-3 items-center text-sm">
              <CryptoIconWrapper name={token.symbol.toLowerCase()} size={32} />
              <h3>{token.symbol}</h3>
              <p className="text-gray-400">{token.name}</p>
            </div>
            <div className="flex">
              <div className="token-header gap-4 mt-2 flex items-center">
                <div className="token-stats">
                  <span className="text-md font-bold">
                    $
                    {token.currentPrice.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </span>
                  {showStats && token.momentum && (
                    <div className="momentum-indicator">
                      <TrendingUp size={14} />
                      <span>{token.momentum.toFixed(2)}x</span>
                    </div>
                  )}
                </div>
                <div
                  className={`percent-change h-5 ${token.percentChange >= 0 ? "positive" : "negative"
                    }`}
                >
                  {token.percentChange > 0 ? "+" : ""}
                  {token.percentChange}%
                </div>
              </div>

            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

TokenStats.propTypes = {
  tokens: PropTypes.arrayOf(
    PropTypes.shape({
      symbol: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      percentChange: PropTypes.number.isRequired,
      currentPrice: PropTypes.number.isRequired,
      momentum: PropTypes.number,
    })
  ).isRequired,
  showStats: PropTypes.bool,
};

TokenStats.defaultProps = {
  showStats: false,
};

export default TokenStats;
